import strings from './strings';
import translate from './translate';

const { parameterize } = strings;

export { parameterize, translate };
